export default "__VITE_ASSET__CevWaiA1__"